<!-- Barra de filtros — mesmo arranjo da aba "Sessões" do detalhe do grupo empresa. -->
<div class="d-flex justify-content-between align-items-end flex-wrap gap-2 mb-3">
  <div class="d-flex flex-wrap gap-2 align-items-end">
    <div class="form-check mb-1">
      <input
        class="form-check-input"
        type="checkbox"
        id="my-sessions-only-active"
        [(ngModel)]="filters.only_active"
        (change)="applyFilters()" />
      <label class="form-check-label text-sm" for="my-sessions-only-active">Só ativas agora</label>
    </div>

    <div class="form-check mb-1">
      <input
        class="form-check-input"
        type="checkbox"
        id="my-sessions-only-linked"
        [(ngModel)]="filters.only_linked"
        (change)="applyFilters()" />
      <label class="form-check-label text-sm" for="my-sessions-only-linked">Só com assento</label>
    </div>

    <patron-button
      color="secondary"
      variant="outline"
      size="sm"
      patron-tooltip="Limpar busca e filtros"
      (click)="clearFilters()">
      Limpar
    </patron-button>

    <patron-button
      color="secondary"
      variant="outline"
      size="sm"
      iconName="bi-arrow-clockwise"
      [loading]="refreshing"
      [disabled]="refreshing || loading"
      patron-tooltip="Recarregar as sessões"
      (click)="reloadNow()">
      Recarregar
    </patron-button>
  </div>

  <patron-search-widget
    placeholder="Buscar por dispositivo, IP ou sistema"
    (onSearch)="onSearch($event)">
  </patron-search-widget>
</div>

@if (lastUpdatedAt && !loading) {
  <div class="d-flex justify-content-end mb-2">
    <small class="text-muted">
      <i class="bi bi-arrow-repeat me-1"></i>Atualizado às {{ lastUpdatedAt | date: 'HH:mm:ss' }}
    </small>
  </div>
}

<!-- Loading em bloco, no lugar da tabela: o [loading] da patron-responsive-table cobre a tela toda. -->
@if (loading) {
  <div class="tab-loading">
    <patron-spinner></patron-spinner>
    <p class="mt-2 mb-0 text-muted">Carregando sessões...</p>
  </div>
} @else {
  <patron-responsive-table
    [items]="sessions"
    [bodyTemplate]="sessionsBody"
    [enableSelection]="false"
    [findOptions]="findOptions"
    [mobileSortable]="false"
    customEmptyMessage="Nenhuma sessão encontrada.">
    <ng-template #sessionsBody let-session>
      <tr>
        <td>
          <patron-rt-column-title><strong>Dispositivo</strong></patron-rt-column-title>
          <span [patron-tooltip]="session.user_agent || ''">{{ sessionDevice(session) }}</span>
        </td>
        <td>
          <patron-rt-column-title><strong>IP</strong></patron-rt-column-title>
          {{ dash(session.ip_address) }}
        </td>
        <td>
          <patron-rt-column-title><strong>Sistema</strong></patron-rt-column-title>
          {{ dash(session.system_name) }}
        </td>
        <td>
          <patron-rt-column-title><strong>Assento</strong></patron-rt-column-title>
          @if (session.web_license) {
            <span class="badge bg-primary">{{ seatLabel(session) }}</span>
          } @else {
            <span class="text-muted">—</span>
          }
        </td>
        <td>
          <patron-rt-column-title><strong>Situação</strong></patron-rt-column-title>
          @if (session.is_current) {
            <span class="badge bg-success">Esta sessão</span>
          } @else if (isInactive(session)) {
            <span class="badge bg-secondary">Inativa</span>
          } @else {
            <span class="badge bg-primary">Ativa</span>
          }
        </td>
        <td>
          <patron-rt-column-title><strong>Início</strong></patron-rt-column-title>
          {{ dash(session.created_at | date: 'dd/MM/yyyy HH:mm') }}
        </td>
        <td>
          <patron-rt-column-title><strong>Último acesso</strong></patron-rt-column-title>
          {{ dash(session.last_request_at | date: 'dd/MM/yyyy HH:mm') }}
        </td>
        <td class="text-end">
          <patron-rt-column-title><strong>Ações</strong></patron-rt-column-title>
          <patron-button
            size="sm"
            [color]="session.is_current ? 'warning' : 'danger'"
            variant="outline"
            iconName="pi-sign-out"
            [patron-tooltip]="
              session.is_current
                ? 'Sair desta sessão (você será deslogado)'
                : 'Encerrar esta sessão'
            "
            (click)="askEndSession(session)">
          </patron-button>
        </td>
      </tr>
    </ng-template>
  </patron-responsive-table>
}

<patron-paginator
  [totalRecords]="totalItems"
  [first]="paginatorFirst"
  [findOptions]="findOptions"
  (onPageChange)="paginate($event)">
</patron-paginator>

<patron-modal
  [visible]="confirmVisible"
  [title]="confirmTarget?.is_current ? 'Sair desta sessão' : 'Encerrar sessão'"
  [backdrop]="'static'"
  [confirmButtonText]="confirmTarget?.is_current ? 'Sair' : 'Confirmar'"
  [confirmButtonLoading]="confirmLoading"
  (confirm)="runEndSession()"
  (cancel)="confirmVisible = false"
  (visibleChanged)="confirmVisible = $event">
  @if (confirmTarget) {
    @if (confirmTarget.is_current) {
      <div class="alert alert-warning mb-0">
        Esta é a sessão que você está usando agora. Ao encerrá-la, você será
        <strong>deslogado</strong> e precisará fazer login novamente.
      </div>
    } @else {
      <p>
        O dispositivo <strong>{{ sessionDevice(confirmTarget) }}</strong> será desconectado e
        precisará fazer login novamente.
      </p>
      @if (confirmTarget.web_license) {
        <div class="alert alert-warning mb-0">
          Esta sessão está ocupando o assento <strong>{{ seatLabel(confirmTarget) }}</strong> —
          encerrá-la também <strong>libera a licença</strong>.
        </div>
      }
    }
  }
</patron-modal>
